export default __webpack_public_path__ + "static/media/folder.2dfd54ec.svg";